import { IContentOverlay } from '@models/IContentOverlay';
import ContentOverlay from '@molecules/ContentOverlay/ContentOverlay';
import classNames from 'classnames';

interface Props {
  readonly title?: string;
  readonly items: {
    readonly name?: string;
    readonly overlay?: IContentOverlay;
  }[];
  readonly itemNameClass?: string;
  readonly itemsGapClass?: string;
  readonly bulletMarginClass?: string;
  readonly bulletSizeClass?: string;
  readonly dataTestId?: string;
}

const BulletList = ({
  title,
  items,
  itemNameClass = 'body-three',
  itemsGapClass = 'gap-y-[15px] lg:gap-y-[17px]',
  bulletMarginClass = 'mr-5',
  bulletSizeClass = 'h-3 w-3',
  dataTestId = 'Bullet-List',
}: Props) => {
  const filteredItems = items.filter((item) => !!item.name);
  if (!filteredItems.length) return null;

  return (
    <div data-testid={dataTestId}>
      {title && (
        <p className="h6 mb-5" data-testid={`${dataTestId}-Title`}>
          {title}
        </p>
      )}

      <ul
        className={classNames('flex flex-col', itemsGapClass)}
        data-testid={`${dataTestId}-Items`}
      >
        {filteredItems.map((item, index) => (
          <li
            className="flex"
            key={item.name}
            data-testid={`${dataTestId}-Item-${index}`}
          >
            <div className={classNames('flex items-center', bulletMarginClass)}>
              <div
                className={classNames('rounded-sm bg-yellow', bulletSizeClass)}
              />
            </div>

            <div
              className={itemNameClass}
              data-testid={`${dataTestId}-Item-${index}-Name`}
            >
              {item.name}
            </div>

            {item.overlay && (
              <div className="ml-1.5">
                <ContentOverlay
                  {...item.overlay}
                  dataTestId={`${dataTestId}-Item-${index}-Overlay`}
                />
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BulletList;
